<template>
  <div class="home p-layout-grid page-view">
    <!-- right key menu -->
    <p-popover
      ref="rightMenuEle"
      v-show="rightMenu.show"
      :style="{ width: '140px', ...rightMenu.position }"
    >
      <a-menu :selectable="false" @click="rightMenuClick">
        <a-menu-item key="1">
          <a-icon theme="filled" class="picon" type="folder-add" />
          新建文件夹</a-menu-item
        >
        <a-menu-item key="4">
          <a-icon class="picon mr-10" type="upload" />上传文件
        </a-menu-item>
        <a-menu-item key="2">
          <a-icon class="picon" type="edit" theme="filled" />
          重命名</a-menu-item
        >
        <a-menu-item key="3">
          <a-icon class="picon" type="delete" theme="filled" />
          删除</a-menu-item
        >
      </a-menu>
    </p-popover>
    <a-modal
      v-model="modal.isShow"
      :maskClosable="false"
      v-bind="modal.config"
      @ok="saveAddFolder"
      @cancel="
        () => {
          fileList = [];
        }
      "
      :width="480"
    >
      <a-form
        v-if="modal.formItems"
        @submit="saveAddFolder"
        class="min-line"
        :form="modal.form"
        :layout="'horizontal'"
      >
        <a-form-item
          v-for="(item, index) in modal.formItems"
          :key="index"
          :label="item.label"
          v-show="!item.hidden"
        >
          <a-upload
            v-if="item.el == 'aUpload'"
            :fileList="fileList"
            v-decorator="item.decorator"
            :remove="(arr) => (fileList = [])"
            :beforeUpload="beforeUpload"
            :multiple="false"
          >
            <a-button type="primary" :style="{ width: '433px' }">
              <a-icon :type="upload ? 'loading' : 'upload'" />{{
                !upload ? "上传文件" : "...上传中"
              }}
            </a-button>
          </a-upload>
          <component
            v-else
            :is="item.el"
            v-bind="item"
            @keyup.enter="saveAddFolder"
            v-on="item.on"
            v-decorator="item.decorator"
            >{{ item.children }}</component
          >
        </a-form-item>
      </a-form>
    </a-modal>
    <div class="p-sider">
      <div class="logo"></div>
      <a-dropdown class="addBtn" :trigger="['click']" placement="bottomLeft">
        <a-button icon="plus" type="primary">添加</a-button>
        <a-menu slot="overlay">
          <a-menu-item @click="addFolder">
            <a rel="newFolder" href="javascript:">
              <a-icon
                theme="filled"
                class="picon mr-10"
                type="folder-add"
              />新建文件夹</a
            >
          </a-menu-item>
          <a-menu-item @click="showUpdate" v-show="currentRowData">
            <a rel="upload" href="javascript:">
              <a-icon class="picon mr-10" type="upload" />上传文件</a
            >
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <div class="menu-tree-warpper">
        <a-skeleton
          v-if="!gData"
          active
          :paragraph="{ rows: 14 }"
          :rows="20"
          style="padding: 14px"
        />

        <a-tree
          v-if="gData"
          blockNode
          class="p-tree"
          @select="onSelect"
          @rightClick="onRightClick"
          @expand="onExpand"
          @dblclick="onTreeDblclick"
          show-icon
          :selectedKeys="selectedKeys"
          :defaultExpandedKeys="[gData[0].id]"
          :replaceFields="{ key: 'id', title: 'name' }"
          :tree-data="gData"
        >
          <!-- <a-icon slot="switcherIcon" type="down" />
          <a-icon slot="smile" type="smile-o" />
          <a-icon slot="meh" type="smile-o" /> -->

          <template slot="custom" slot-scope="object">
            <a-icon
              theme="filled"
              class="picon"
              :type="
                object.expanded && !object.isLeaf ? 'folder-open' : 'folder'
              "
            />
          </template>
        </a-tree>
      </div>
    </div>
    <div class="p-header">
      <a-button
        :disabled="backID == 0"
        type="link"
        style="padding: 0 15px"
        @click="backClick"
        icon="rollback"
      />
      <a-menu
        class="topbar"
        @click="(item, key) => (topbarKey = [key])"
        v-model="topbarKey"
        mode="horizontal"
      >
        <a-menu-item class="topbar-item" key="1">
          <a-icon theme="filled" type="appstore" />
        </a-menu-item>
        <a-menu-item class="topbar-item" key="0">
          <a-icon type="menu" />
        </a-menu-item>
      </a-menu>
      <a-input-search
        allow-clear
        style="margin: 0 10px"
        placeholder="search text"
        @search="onSearch"
      />
    </div>
    <div class="p-content">
      <div class="p-content-body">
        <a-table
          :scroll="topbarKey[0] === '1' ? undefined : { x: true }"
          v-if="gData && columns"
          tableLayout="fixed"
          class="sm scroll"
          :class="topbarKey[0] === '1' ? 'list-panel' : ''"
          :columns="columns"
          rowKey="id"
          :rowClassName="rowClassName"
          :customRow="customRow"
          :dataSource="dataSource"
          :loading="tableLoading"
          :pagination="false"
        >
          <div class="name-item" slot="nameItem" slot-scope="text, data">
            <div class="img-wrapper">
              <div
                class="img-pic"
                :class="data.type"
                :style="
                  topbarKey[0] === '1' && { ...judegUrl(data.id, data.type) }
                "
              ></div>
            </div>
            <div class="nameItem-text">{{ text }}</div>
          </div>
        </a-table>
      </div>
    </div>
    <div class="p-pages">
      <!-- 分页 -->
      <a-Pagination
        v-bind="pagination"
        @showSizeChange="tableChange"
        @change="tableChange"
      />
    </div>
    <div class="p-info">
      <a-card class="sm" size="small" :bordered="false" title="文件信息">
        <div
          v-if="currentRowData"
          class="img-pic"
          :class="currentRowData.type"
          :style="setImagerUrl"
        ></div>
        <a-form
          class="sm-line"
          :layout="'horizontal'"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-item
            v-for="(item, index) in infoList"
            :key="index"
            :label="item.label"
          >
            {{ item.value }}
          </a-form-item>
        </a-form>
      </a-card>
      <a-button
        :disabled="!currentRowData"
        class="btn-download"
        type="primary"
        shape="round"
        icon="download"
        @click="download"
        size="large"
        >下载文件
      </a-button>
    </div>
  </div>
</template>
<script>
import {
  customRender,
  updateFormItems,
  setFormItems,
  setColumns,
  initPages,
  setId,
  remId,
} from "./index.home.js";
import PPopover from "./p_popover.vue";

export default {
  name: "home",
  components: { PPopover },
  data() {
    return {
      currentRowData: null,
      topbarKey: ["0"],
      rightMenu: {
        show: false,
        position: {},
      },
      infoList: [],
      activeRowID: "",
      gData: null,
      selectedKeys: [],
      expandedKeys: [],
      modal: {
        //保存弹出框
        isShow: false,
        state: 0,
        form: this.$form.createForm(this),
        formItems: null,
        config: {
          okText: "确定",
          cancelText: "取消",
        },
      },
      dataSource: [],
      tableLoading: true,
      pagination: initPages(),
      mapObjcet: {},
      fileList: [],
      upload: false,
    };
  },
  created() {},
  computed: {
    backID() {
      if (!this.currentRowData) return 0;
      if (this.currentRowData.parentId === "0") {
        return 0;
      } else {
        return this.currentRowData.type !== "folder"
          ? this.mapObjcet[this.currentRowData.parentId].parentId
          : this.mapObjcet[this.selectedKeys[0]].parentId;
      }
    },
    setImagerUrl() {
      if (this.currentRowData);
      let _type = this.currentRowData.type;
      return this.judegUrl(this.currentRowData.id, _type);
    },
    columns() {
      let col = setColumns(this);
      if (this.topbarKey[0] === "1") {
        col = col.filter((item) => {
          if (item.dataIndex == "name") {
            return item;
          }
        });
        return col;
      }
      return col;
    },
  },

  mounted() {
    this.setFolderTreeData();
    document.addEventListener(
      "click",
      function () {
        this.rightMenu.show = false;
      }.bind(this)
    );
  },
  methods: {
    backClick() {
      if (this.backID == 0) return this.backID;
      let _this = this;
      this.selectedKeys = [this.backID];
      this.getFileData().then(() => {
        if (_this.currentRowData.type !== "folder") {
          _this.currentRowData = _this.mapObjcet[_this.currentRowData.parentId];
          _this.activeRowID = _this.currentRowData.id;
        }

        _this.setInfoList(_this.currentRowData);
        _this.infoList[1].value = this.dataSource.length;
      });
    },
    judegUrl(id, _type) {
      if (
        _type == "jpg" ||
        _type == "jpeg" ||
        _type == "gif" ||
        _type == "svg" ||
        _type == "png"
      ) {
        return {
          backgroundImage: `url(${this.$apis.getImages(remId(id))})`,
          width: "100%",
          height: "100%",
        };
      }
      return {};
    },
    onSearch(value, event) {
      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      var arr = [];
      var _this = this;
      var params = {};
      if (value) {
        arr = Object.values(this.mapObjcet).filter((item) => {
          return String(item.name).indexOf(value) > -1;
        });
        params.name = value;
        params.directoryId = "";
        this.getFileData(params, false).then(() => {
          _this.infoList = [];
          _this.dataSource = _this.dataSource.concat(arr);
          _this.pagination.total = _this.dataSource.length;
          _this.selectedKeys = [];
        });
      } else {
        this.getFileData(params).then(() => {
          this.infoList = [];
        });
      }
    },
    beforeUpload(file) {
      this.fileList = [file];
      return false;
    },
    showUpdate() {
      this.modal.state = 3;
      this.modal.form.resetFields();
      this.modal.isShow = true;
      this.modal.formItems = updateFormItems(this);
    },
    addFolder() {
      this.modal.state = 1;
      this.modal.form.resetFields();
      this.modal.isShow = true;
      this.modal.formItems = setFormItems();
      this.modal.formItems[1].label = "添加新文件到当前目录";
    },
    resetName(id) {
      this.modal.state = 2;
      this.modal.isShow = true;
      this.modal.formItems = setFormItems();
      this.modal.formItems[this.modal.formItems.length - 1] = {};
      this.$nextTick(() => {
        this.modal.formItems[1].label = "重命名";
        //this.modal.state = 2;
        //this.currentRowData.name.split(".")[1]
        this.modal.form.setFieldsValue({
          id: id,
          name: this.currentRowData.name,
        });
      });
    },

    download(event) {
      let id = remId(this.currentRowData.id);
      let _this = this;
      //   var blob = new Blob([response.data])
      var downloadElement = document.createElement("a");
      //  downloadElement.download = this.currentRowData.name;

      var href = this.$apis.downloadFile(id); //创建下载的链接
      if (this.currentRowData.type == "folder") {
        var href = this.$apis.downloadFileAll(id);
      }
      downloadElement.href = href;

      //  downloadElement.download = '用户数据.xlsx'; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    delete(id, type) {
      let _this = this;
      let url = _this.$apis.delFolder();
      if (type !== "folder") {
        url = _this.$apis.delFile();
      }
      this.$confirm({
        title: "是否删除?",
        okText: "Yes",
        cancelText: "No",
        onOk: () => {
          _this
            .axios({
              url: url,
              method: "post",
              params: {
                id,
              },
            })
            .then((res) => {
              if (res.success) {
                _this.$message.success("删除成功");
                _this.setFolderTreeData().then(() => {
                  _this.getFileData();
                });
              } else {
                _this.$error({
                  title: "Message",
                  content: res.message,
                });
              }
            });
        },
      });
    },
    rowClassName(record, index) {
      return record.id === this.activeRowID ? "active" : "";
    },
    setInfoList(object) {
      this.infoList = [
        { label: "名称", value: object.name },
        { label: "", value: object.size },
        { label: "储存方式", value: customRender(object.storageType) },
        { label: "创建时间", value: object.createTime },
      ];
      if (object.type == "folder") {
        var count = this.mapObjcet[object.id].children;
        this.infoList[1].label = "文件数量";
        this.infoList[1].value = count ? count.length : 0;
      } else {
        this.infoList[1].label = "文件大小";
      }
      this.infoList.push({ label: "id", value: object.id });
    },
    rightMenuClick(obj) {
      var data = this.currentRowData;
      //加目录
      if (obj.key == 1) {
        return this.addFolder();
      }
      //删除
      if (obj.key == 3) {
        return this.delete(remId(data.id), data.type);
      }
      if (obj.key == 2) {
        //修改名称
        return this.resetName(remId(data.id));
      }
      if (obj.key == 4) {
        //上传文件
        return this.showUpdate();
      }
    },
    customRow(record) {
      let _this = this;
      return {
        props: {},
        on: {
          // 单击行
          click: (event) => {
            _this.activeRowID = record.id;
            _this.setInfoList(record);
            // _this.infoList[1].value = _this.dataSource.length

            _this.currentRowData = record;
          },
          // 双击行
          dblclick: (event) => {
            event.preventDefault();
            if (record.type == "folder") {
              _this.selectedKeys = [record.id];
              _this.getFileData();
            }
          },
          //右健
          contextmenu: (event) => {
            event.preventDefault();
            _this.autoPosition(event);
            _this.rightMenu.show = !_this.rightMenu.show;
            _this.currentRowData = record;
            setTimeout(() => {
              _this.rightMenu.show = true;
              _this.rightMenu.data = record;
            }, 100);
          },
          mouseenter: (event) => {}, // 鼠标移入行
          mouseleave: (event) => {},
        },
      };
    },
    autoPosition(event) {
      var height = 202;
      var offsetTop = event.clientY;
      var hCount = window.innerHeight - offsetTop;
      var top = event.clientY;
      var left = event.clientX;
      if (hCount < height) {
        top = top - height;
        if (offsetTop < height) {
          top = 2 / top;
        }
      }
      this.rightMenu.position = {
        top: top + "px",
        left: left + "px",
      };
    },
    getFolderData() {
      let _this = this;
      this.axios({
        url: _this.$apis.getFolder(),
      }).then((res) => {
        if (res.success) {
          _this.gData = DG(res.data);
          if (_this.selectedKeys.length === 0) {
            _this.selectedKeys = [setId(_this.gData[0].id)];
            _this.getFileData().then(() => {
              _this.setInfoList(_this.mapObjcet[_this.selectedKeys[0]]);
              _this.infoList[1].value = _this.dataSource.length;
            });
          }
        }
      });
    },
    /**请求目录数据 */
    setFolderTreeData() {
      let _this = this;
      var DG = (data) => {
        let map = {};
        data.forEach((item) => {
          delete item.children;
          item.isLeaf = !!item.isLeaf;
          item.id = setId(item.id);
          item.type = "folder";
          item.parentId = setId(item.parentId);
          item.scopedSlots = { icon: "custom" };
          map[item.id] = item;
        });
        this.mapObjcet = map;
        let value = [];
        data.forEach((item) => {
          var p = map[item.parentId];
          if (p) {
            if (!p.children) {
              p.children = [];
            }
            p.children.push(item);
          } else {
            value.push(item);
          }
        });
        return value;
      };

      return this.axios({
        url: _this.$apis.getFolder(),
      }).then((res) => {
        if (res.success) {
          _this.gData = DG(res.data);
          if (_this.selectedKeys.length === 0) {
            _this.selectedKeys = [setId(_this.gData[0].id)];
            _this.getFileData().then(() => {
              _this.currentRowData = _this.mapObjcet[_this.selectedKeys[0]];
              _this.setInfoList(_this.currentRowData);
              _this.infoList[1].value = _this.dataSource.length;
            });
          }
        }
      });
    },
    onSelect(keys, event) {
      let _this = this;

      if (keys.length == 0) return this.selectedKeys;
      this.selectedKeys = keys;
      this.getFileData().then(() => {
        _this.currentRowData = event.node.$vnode.data.props.dataRef;
        _this.setInfoList(_this.currentRowData);
        _this.infoList[1].value = this.dataSource.length;
      });
    },
    onTreeDblclick(e) {
      let element;
      if (e.toElement.className == "ant-tree-title") {
        element = e.toElement.parentNode.previousSibling;
        element.click();
      }
    },
    onExpand(expandedKeys, object) {
      this.expandedKeys = expandedKeys;
    },
    //树右键
    onRightClick({ event, node }) {
      let _this = this;
      _this.autoPosition(event);
      _this.rightMenu.show = !_this.rightMenu.show;
      _this.currentRowData = node.$vnode.data.props.dataRef;
      setTimeout(() => {
        _this.rightMenu.show = true;
      }, 100);
    },
    saveAddFolder(e) {
      let _this = this;
      this.modal.form.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        let params = {},
          url = "",
          parentId = this.selectedKeys[0] ? remId(this.selectedKeys[0]) : 0,
          opt = {};
        //添加
        if (this.modal.state === 1) {
          url = this.$apis.addFolder();
          parentId = fieldsValue.is ? 0 : this.selectedKeys[0];
          params = {
            name: fieldsValue.name,
            parentId: parentId,
          };

          //重命名
        } else if (this.modal.state === 2) {
          url = this.$apis.updateFolder();
          if (this.currentRowData && this.currentRowData.type !== "folder") {
            url = this.$apis.updateFile();
          }
          parentId = null;
          params = {
            name: fieldsValue.name,
            id: fieldsValue.id,
          };
        } else if (this.modal.state === 3) {
          this.upload = true;
          //上传
          url = this.$apis.uploadFile();
          if (fieldsValue.file) {
            fieldsValue.file = fieldsValue.file.fileList[0].originFileObj;
          }
          //   fieldsValue.directoryId = parentId
          if (_this.currentRowData.type == "folder") {
            fieldsValue.directoryId = remId(_this.currentRowData.id);
          } else {
            fieldsValue.directoryId = _this.selectedKeys[0];
          }
          fieldsValue.directoryAdd = "";
          _this.currentRowData;
          console.log(_this.currentRowData);
          console.log(_this.mapObjcet);
          params = new FormData();

          Object.keys(fieldsValue).forEach((key) => {
            params.append(key, fieldsValue[key]);
          });
          opt = {
            processData: false, // 告诉axios不要去处理发送的数据(重要参数)
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          //   	file
          // directoryId	string	query		目录id
          // directoryAdd	string	query		目录地址(多层级用'/'分隔)
          // storageType	integer

          return this.axios({
            url: url,
            method: "post",
            data: params,
            ...opt,
          })
            .then((res) => {
              if (res.success) {
                _this.fileList = [];
                _this.$message.success(res.message);
                if (_this.currentRowData.type == "folder") {
                  _this.selectedKeys = [_this.currentRowData.id];
                }
                _this.setFolderTreeData().then(() => {
                  _this.getFileData();
                });
              } else {
                _this.$error({
                  title: "Message",
                  content: res.message,
                });
              }
              _this.modal.isShow = false;
              _this.upload = false;
            })
            .catch((res) => {
              _this.$error({
                title: "Message",
                content: res,
              });
            });
        } else {
          return;
        }

        return this.axios({
          url: url,
          method: "post",
          params: params,
        }).then((res) => {
          if (res.success) {
            _this.fileList = [];
            _this.$message.success(res.message);
            _this.$nextTick(() => {
              _this.setFolderTreeData().then(() => {
                _this.getFileData();
                console.log("over", this.currentRowData);
              });
            });
            _this.modal.isShow = false;
          } else {
            _this.$message.error(res.message);
          }
        });
      });
    },
    getFileData(params = {}, mapObjcet = this.mapObjcet) {
      let _this = this;
      let directoryId = this.selectedKeys[0];
      _this.tableLoading = true;
      var arr = [];

      _this.pagination.current === 1 &&
        mapObjcet &&
        Object.values(mapObjcet).forEach((item) => {
          if (item.parentId === directoryId) {
            arr.push(item);
          }
        });

      return this.axios({
        url: this.$apis.getFile(),
        params: {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize - arr.length,
          directoryId: remId(directoryId),
          ...params,
        },
      })
        .then((res) => {
          if (res.success) {
            res.data.list.forEach((item) => {
              item.parentId = item.directoryId;
            });

            res.data.pageSize += arr.length;
            res.data.totalCount = +res.data.totalCount+arr.length;
            _this.dataSource = arr.concat(res.data.list);
            _this.cbPagersObj(_this.pagination, res.data);
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    cbPagersObj(pagination, data) {
      pagination.pageSize = data.pageSize;
      pagination.total = data.totalCount;
      return pagination;
    },
    tableChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.getFileData();
    },
  },
};
</script>
<style lang='less'>
@import "~@/css/theme.less";


.topbar {
  height: 100%;
  padding: 0 5px;
  border-bottom: 0;
}
.topbar-item {
  padding: 0 15px;
  top: 5px !important;
  i {
    margin-right: 0 !important;
    min-width: 18px !important;
    font-size: 18px !important;
  }
}
.p-layout-grid {
  display: grid;
  grid-template-columns: auto 1fr 350px;
  grid-template-rows: 53px 1fr auto;
  background-color: #fff;
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background-color: transparent;
  }
  .ant-table-tbody > tr.active {
    background: #ebebeb;
  }
}
.p-sider {
  border-right: 1px solid #e4e4e4;
  //grid-row: 1 / 4;
  grid-row-start: 1;
    grid-row-end: 4;
  width: 244px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.menu-tree-warpper {
  overflow: auto;
  display: flex;
  flex: 1;
}
.p-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e4e4e4;
    grid-column-start: 2;
    grid-column-end: 4;
}

.p-content {
  position: relative;
  background: #f7f7f7;
    grid-column-start: 2;
    grid-column-end: 3;
  overflow: hidden;
}
.p-content-body {
  height: 100%;
  overflow-y: auto;
}
.p-pages {
  padding: 10px 16px;
  text-align: right;
  border-top: 1px solid #e4e4e4;
  background: #fff;
  //grid-column: 2/ 3;
    grid-column-start: 2;
    grid-column-end: 3;
  //grid-row: 3/ 4;
    grid-row-start: 3;
    grid-row-end: 4;
}
.addBtn {
  display: block;
  margin: 15px auto;
  width: 90%;
}
.p-info {
  position: relative;
  background: #fff;
  border-left: 1px solid #e4e4e4;
  //grid-row: 2/ 4;
   grid-row-start: 2;
    grid-row-end: 4;
}
.btn-download {
  position: absolute;
  bottom: 50px;
  left: 0;
  margin: 0 auto;
  width: 90%;
  right: 0;
}
.picon {
  color: #999999;
  font-size: 1.2em !important;
  vertical-align: sub;
}
.logo {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  background: url("~@/assets/logo.svg");
}
.p-tree.ant-tree {
  padding-left: 8px;
  padding-right: 13px;
  width: 100%;

  .ant-tree-treenode-selected {
    & > .ant-tree-node-content-wrapper {
      .anticon {
        color: #ffffff;
      }
     background-color:@primary-color;
    color: #fff;
    }
  }
}

.name-item {
  display: flex;
}

.p-info .img-pic {
  margin-bottom: 10px;

  width: 100%;
  padding-bottom: 50%;
}
.img-wrapper {
  display: flex;
}
.img-pic {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 40px;
  height: inherit;
  background-image: url("~@/assets/other.svg");
  &.folder {
    background-image: url("~@/assets/folder.svg");
  }
  &.pdf {
    background-image: url("~@/assets/pdf.svg");
  }
  &.jpeg,
  &.jpg,
  &.png,
  &.gif,
  &.svg {
    background-image: url("~@/assets/jpg.svg");
  }
  &.docx,
  &.doc {
    background-image: url("~@/assets/doc.svg");
  }
  &.xls,
  &.xlsx {
    background-image: url("~@/assets/excel.svg");
  }
}

.ant-table-wrapper.list-panel {
  thead {
    display: none;
  }
  .name-item {
    flex-direction: column;
  }
  .img-wrapper {
    width: 100%;
    background: #fff;
    display: block;
    border: 1px solid #e4e4e4;
    padding-top: 100%;
    overflow: hidden;
    position: relative;
  }
  .img-pic {
    width: 50%;
    height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    right: 0;
    bottom: 0;
    transform: translate(-50%, -50%);
  }
  .nameItem-text {
    padding: 6px 8px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
  }

  .ant-table-tbody {
    & > tr > td {
      border: 0;
    }
    td {
      display: block;
    }
    display: grid;
    grid-template-columns: repeat(8, 12.5%);
  }
}
</style>